import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserManagmentMainComponent } from './user-managment-main/user-managment-main.component';
import { UserManagementListComponent } from './user-management-list/user-management-list.component';
import { UserManagementAddComponent } from './user-management-add/user-management-add.component';
import { UserManagementDetailsComponent } from './user-management-details/user-management-details.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';
const routes: Routes = [
  { path: 'user-management', component: UserManagmentMainComponent, canActivate: [AuthGuard],
  children: [
    { path: '', pathMatch:'full', component: UserManagementListComponent},
    { path: 'edit/:id', pathMatch:'full', component: UserManagementDetailsComponent, canActivate: [AuthGuard]},
    { path: 'add', pathMatch:'full', component: UserManagementAddComponent, canActivate: [AuthGuard]},
  ]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/user-management/user-management-routing.module.ts